/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-06 11:37:45
 * @FilePath: \mrc-ess-fronted\src\router\routers.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-29 15:32:13
 */

import Pages from "@/router/pages";
export default [
  {
    path: "/404",
    name: "404Page",
    component: Pages["Page404"],
  },
  {
    path: "/net_error",
    name: "NetErrorPage",
    component: Pages["NetError"],
  },
  {
    path: "/system_error",
    name: "SystemErrorPage",
    component: Pages["SystemErrorPage"],
  },
  {
    path: "dashboard",
    name: "label_essweb_dashboard_list_title",
    component: Pages["Dashboard"],
    meta: {
      router: "/dashboard",
      icon: "",
      bred: "/dashboard",
    },
  },
  //Calendar
  {
    path: "calendar",
    name: "Calendar",
    component: Pages["Calendar"],
    meta: {
      router: "/calendar",
      icon: "",
      text: "label_essweb_calendar_list_title",
      bred: "/calendar",
    },
  },
  // Block Leave
  {
    path: "block-leave-record",
    name: "Block Leave Record",
    component: Pages["BlockLeaveRecord"],
    meta: {
      router: "/block-leave-record",
      icon: "",
      text: "label_essweb_myBlockLeaveRecord_list_title",
      bred: "/block-leave-record",
    },
  },
  {
    path: "subordinate-block-leave-record",
    name: "Subordinate Block Leave Record",
    component: Pages["SubordinateBlockLeaveRecord"],
    meta: {
      router: "/subordinate-block-leave-record",
      icon: "",
      text: "label_essweb_subordinateBlockLeaveRecord_list_title",
      bred: "/subordinate-block-leave-record",
    },
  },
  // Leave
  {
    path: "leave-application",
    name: "Leave Applications",
    component: Pages["LeaveApplication"],
    meta: {
      router: "/leave-application",
      icon: "",
      keepAlive: true,
      text: "label_essweb_leaveApplication_list_title",
      bred: "/leave-application",
    },
  },
  {
    path: "leave-application/leave-detail/:params",
    name: "View Leave Application",
    component: Pages["viewLeaveApplication"],
    meta: {
      router: "/leave-application/leave-detail/:params",
      icon: "",
      cachePre: true, //缓存上一页
      text: "label_essweb_leaveApplication_form_viewTitle",
      bred: "/leave-application/leave-detail/:params",
    },
  },
  {
    path: "leave-application/add/:id",
    name: "New Leave Application",
    component: Pages["newLeaveApplication"],
    meta: {
      router: "/leave-application/add/:id",
      cachePre: true, //缓存上一页
      icon: "",
      text: "label_essweb_leaveApplication_form_newTitle",
      bred: "/leave-application/add/:id",
    },
  },
  {
    path: "leave-application/leave-detail/:params/approval-detail/:args",
    name: "Leave Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/leave-application/leave-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/leave-application/leave-detail/:params/approval-detail/:args",
    },
  },
  //Leave Balance
  {
    path: "leave-balance",
    name: "Leave Balance",
    component: Pages["LeaveBalance"],
    meta: {
      router: "/leave-balance",
      icon: "",
      text: "label_essweb_leaveBalance_list_title",
      bred: "/leave-balance",
    },
  },

  // Leave Application On Behalf
  {
    path: "leave-application-on-behalf",
    name: "Leave Application On Behalf",
    component: Pages["LeaveApplicationOnBehalf"],
    meta: {
      router: "/leave-application-on-behalf",
      icon: "",
      text: "label_essweb_leaveApplicationOnBehalf_list_title",
      bred: "/leave-application-on-behalf",
    },
  },
  {
    path: "leave-application-on-behalf/add/:args",
    name: "New Leave Application On Behalf",
    component: Pages["NewLeaveApplicationOnBehalf"],
    meta: {
      router: "/leave-application-on-behalf/add/:args",
      icon: "",
      text: "label_essweb_leaveApplicationOnBehalf_form_newTitle",
      bred: "/leave-application-on-behalf/add/:args",
    },
  },
  {
    path: "leave-application-on-behalf/detail/:params",
    name: "View Leave Application On Behalf",
    component: Pages["ViewLeaveApplicationOnBehalf"],
    meta: {
      router: "/leave-application-on-behalf/detail/:params",
      icon: "",
      text: "label_essweb_leaveApplicationOnBehalf_form_viewTitle",
      bred: "/leave-application-on-behalf/detail/:params",
    },
  },
  {
    path: "leave-application-on-behalf/detail/:params/approval-detail/:args",
    name: "OnBehalf Leave Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/leave-application-on-behalf/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/leave-application-on-behalf/detail/:params/approval-detail/:args",
    },
  },
  // Subordinate Leave Application
  {
    path: "subordinate-leave-application",
    name: "Subordinate Leave Application",
    component: Pages["SubordinateLeaveApplication"],
    meta: {
      router: "/subordinate-leave-application",
      icon: "",
      text: "label_essweb_subordinateLeaveApplication_list_title",
      bred: "/subordinate-leave-application",
    },
  },
  {
    path: "subordinate-leave-application/detail/:params",
    name: "View Subordinate Leave Application",
    component: Pages["ViewSubordinateLeaveApplication"],
    meta: {
      router: "/subordinate-leave-application/detail/:params",
      icon: "",
      text: "label_essweb_subordinateLeaveApplication_form_viewTitle",
      bred: "/subordinate-leave-application/detail/:params",
    },
  },
  {
    path: "subordinate-leave-application/detail/:params/approval-detail/:args",
    name: "Subordinate Leave Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/subordinate-leave-application/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/subordinate-leave-application/detail/:params/approval-detail/:args",
    },
  },
  // Subordinate Leave Balance
  {
    path: "subordinate-leave-balance",
    name: "Subordinate LeaveBalance",
    component: Pages["SubordinateLeaveBalance"],
    meta: {
      router: "/subordinate-leave-balance",
      icon: "",
      text: "label_essweb_subordinateLeaveBalance_list_title",
      bred: "/subordinate-leave-balance",
    },
  },
  {
    path: "/subordinate-leave-balance/detail/:id",
    name: "view Subordinate Leave Balance",
    component: Pages["ViewSubordinateLeaveBalance"],
    meta: {
      router: "/subordinate-leave-balance/detail/:id",
      icon: "",
      text: "label_essweb_subordinateLeaveBalance_form_viewTitle",
      bred: "/subordinate-leave-balance/detail/:id",
    },
  },
  //排班记录
  {
    path: "duty-roster",
    name: "Roster Records",
    component: Pages["RosterRecord"],
    meta: {
      router: "/duty-roster",
      icon: "",
      text: "label_essweb_RosterRecord_list_title",
      bred: "/duty-roster",
    },
  },
  {
    path: "roster-form-record",
    name: "Roster Form Record1",
    component: Pages["RosterFormRecord"],
    meta: {
      router: "/roster-form-record",
      icon: "",
      keepAlive: true,
      text: "label_essweb_RosterFormRecord_list_title",
      bred: "/roster-form-record",
    },
  },
  {
    path: "roster-form-record/detail/:id",
    name: "View Roster Form Record",
    component: Pages["ViewRosterFormRecord"],
    meta: {
      router: "/roster-form-record/detail/:id",
      icon: "",
      cachePre: true,
      text: "label_essweb_RosterFormRecord_form_viewTitle",
      bred: "/roster-form-record/detail/:id",
    },
  },
  {
    path: "roster-form-record/edit/:id",
    name: "Edit Roster Form Record",
    component: Pages["EditRosterFormRecord"],
    meta: {
      router: "/roster-form-record/edit/:id",
      icon: "",
      cachePre: true,
      text: "label_essweb_RosterFormRecord_form_editTitle",
      bred: "/roster-form-record/edit/:id",
    },
  },
  //我的工作安排
  {
    path: "my-roster",
    name: "My Shift",
    component: Pages["MyShift"],
    meta: {
      router: "/my-roster",
      icon: "",
      text: "label_essweb_myShift_list_title",
      bred: "/my-roster",
    },
  },
  // Claim
  {
    path: "claim-application",
    name: "Claim Application",
    component: Pages["ClaimApplication"],
    meta: {
      router: "/claim-application",
      icon: "",
      text: "label_essweb_myClaimApplication_list_title",
      bred: "/claim-application",
    },
  },
  {
    path: "claim-application/detail/:params",
    name: "view claim Application",
    component: Pages["ViewClaimApplication"],
    meta: {
      router: "/claim-application/detail/:params",
      icon: "",
      text: "label_essweb_myClaimApplication_form_viewTitle",
      bred: "/claim-application/detail/:params",
    },
  },
  {
    path: "claim-application/detail/:params/approval-detail/:args",
    name: "claim Application Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/claim-application/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/claim-application/detail/:params/approval-detail/:args",
    },
  },
  {
    path: "/claim-application/add/:id",
    name: "New claim Application",
    component: Pages["newClaimApplication"],
    meta: {
      router: "/claim-application/add/:id",
      icon: "",
      text: "label_essweb_myClaimApplication_form_newTitle",
      bred: "/claim-application/add/:id",
    },
  },
  // Claim Balance
  {
    path: "claim-balance",
    name: "Claim Balance",
    component: Pages["ClaimBalance"],
    meta: {
      router: "/claim-balance",
      icon: "",
      text: "label_essweb_myClaimBalance_list_title",
      bred: "/claim-balance",
    },
  },
  // My Approval
  {
    path: "my-approval",
    name: "Approval Application",
    component: Pages["ApprovalApplication"],
    meta: {
      router: "/my-approval",
      icon: "",
      text: "label_essweb_approvalApplication_list_title",
      bred: "/my-approval",
    },
  },
  // My Approval--Claim
  {
    path: "my-approval/claim-detail/:params",
    name: "Claim Approval Application Detail",
    component: Pages["ApprovalClaimDetail"],
    meta: {
      router: "/my-approval/claim-detail/:params",
      icon: "",
      text: "label_essweb_myClaimApplication_form_viewTitle",
      bred: "/my-approval/claim-detail/:params",
    },
  },
  {
    path: "my-approval/claim-detail/:params/approval-detail/:args",
    name: "approval claim Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-approval/claim-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-approval/claim-detail/:params/approval-detail/:args",
    },
  },
  // My Approval--Leave
  {
    path: "my-approval/leave-detail/:params",
    name: "Leave Approval Application Detail",
    component: Pages["ApprovalLeaveDetail"],
    meta: {
      router: "/my-approval/leave-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_leaveTitle",
      bred: "/my-approval/leave-detail/:params",
    },
  },
  {
    path: "my-approval/leave-detail/:params/approval-detail/:args",
    name: "approval leave Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-approval/leave-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-approval/leave-detail/:params/approval-detail/:args",
    },
  },
  // My Approval--Custom Form
  {
    path: "my-approval/custom-form-detail/:params",
    name: "custom form Approval Application Detail",
    component: Pages["ApprovalCustomFormDetail"],
    meta: {
      router: "/my-approval/custom-form-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_customFormTitle",
      bred: "/my-approval/custom-form-detail/:params",
    },
  },
  {
    path: "my-approval/custom-form-detail/:params/approval-detail/:args",
    name: "approval custom form Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-approval/custom-form-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-approval/custom-form-detail/:params/approval-detail/:args",
    },
  },
  // My Approval--Abnormal Application
  {
    path: "my-approval/abnormal-detail/:params",
    name: "Abnormal Approval Application Detail",
    component: Pages["ApprovalAbnormalDetail"],
    meta: {
      router: "/my-approval/abnormal-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_abnormalClockinTitle",
      bred: "/my-approval/abnormal-detail/:params",
    },
  },
  {
    path: "my-approval/abnormal-detail/:params/approval-detail/:args",
    name: "approval abnormal Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-approval/abnormal-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-approval/abnormal-detail/:params/approval-detail/:args",
    },
  },
  // My Approval--Attendance Application
  {
    path: "my-approval/attendance-detail/:params",
    name: "Attendance Approval Application Detail",
    component: Pages["ApprovalAttendanceDetail"],
    meta: {
      router: "/my-approval/attendance-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_attendanceTitle",
      bred: "/my-approval/attendance-detail/:params",
    },
  },
  {
    path: "my-approval/attendance-detail/:params/approval-detail/:args",
    name: "approval attendance Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-approval/attendance-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-approval/attendance-detail/:params/approval-detail/:args",
    },
  },
  // My Approval--Roster Application
  {
    path: "my-approval/roster-detail/:params",
    name: "Roster Approval Application Detail",
    component: Pages["ApprovalRosterDetail"],
    meta: {
      router: "/my-approval/roster-detail/:params",
      icon: "",
      text: "label_essweb_approvalApplication_form_viewTitle",
      bred: "/my-approval/roster-detail/:params",
    },
  },
  {
    path: "my-approval/roster-detail/:params/approval-detail/:args",
    name: "approval roster Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-approval/roster-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-approval/roster-detail/:params/approval-detail/:args",
    },
  },
  // Approval OnBehalf
  {
    path: "delegated-approval-record",
    name: "Approval Application OnBehalf",
    component: Pages["ApprovalApplicationOnBehalf"],
    meta: {
      router: "/delegated-approval-record",
      icon: "",
      text: "label_essweb_approvalOnBehalfApplication_list_title",
      bred: "/delegated-approval-record",
    },
  },
  // Approval OnBehalf--Claim
  {
    path: "delegated-approval-record/claim-detail/:params",
    name: "Claim Approval Application Detail onbehalf",
    component: Pages["ApprovalClaimDetailOnBehalf"],
    meta: {
      router: "/delegated-approval-record/claim-detail/:params",
      icon: "",
      text: "label_essweb_myClaimApplication_form_viewTitle",
      bred: "/delegated-approval-record/claim-detail/:params",
    },
  },
  {
    path: "delegated-approval-record/claim-detail/:params/approval-detail/:args",
    name: "Claim Approval Proxy Detail ",
    component: Pages["Status"],
    meta: {
      router:
        "/delegated-approval-record/claim-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/delegated-approval-record/claim-detail/:params/approval-detail/:args",
    },
  },
  // Approval OnBehalf--Leave
  {
    path: "delegated-approval-record/leave-detail/:params",
    name: "Leave Approval Application Detail onbehalf",
    component: Pages["ApprovalLeaveDetailOnBehalf"],
    meta: {
      router: "/delegated-approval-record/leave-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_leaveTitle",
      bred: "/delegated-approval-record/leave-detail/:params",
    },
  },
  {
    path: "delegated-approval-record/leave-detail/:params/approval-detail/:args",
    name: "Leave Approval Proxy Detail ",
    component: Pages["Status"],
    meta: {
      router:
        "/delegated-approval-record/leave-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/delegated-approval-record/leave-detail/:params/approval-detail/:args",
    },
  },
  // Approval OnBehalf--Custom Form
  {
    path: "delegated-approval-record/custom-form-detail/:params",
    name: "custom form Approval Application Detail onbehalf",
    component: Pages["ApprovalCustomFormDetailOnBehalf"],
    meta: {
      router: "/delegated-approval-record/custom-form-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_customFormTitle",
      bred: "/delegated-approval-record/custom-form-detail/:params",
    },
  },
  {
    path: "delegated-approval-record/custom-form-detail/:params/approval-detail/:args",
    name: "custom form Approval Proxy Detail ",
    component: Pages["Status"],
    meta: {
      router:
        "/delegated-approval-record/custom-form-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/delegated-approval-record/custom-form-detail/:params/approval-detail/:args",
    },
  },
  // Approval OnBehalf--Abnormal
  {
    path: "delegated-approval-record/abnormal-detail/:params",
    name: "Abnormal Approval Application Detail onbehalf",
    component: Pages["ApprovalAbnormalDetailOnBehalf"],
    meta: {
      router: "/delegated-approval-record/abnormal-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_abnormalClockinTitle",
      bred: "/delegated-approval-record/abnormal-detail/:params",
    },
  },
  {
    path: "delegated-approval-record/abnormal-detail/:params/approval-detail/:args",
    name: "abnormal Approval Proxy Detail ",
    component: Pages["Status"],
    meta: {
      router:
        "/delegated-approval-record/abnormal-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/delegated-approval-record/abnormal-detail/:params/approval-detail/:args",
    },
  },
  // Approval OnBehalf--Attendance
  {
    path: "delegated-approval-record/attendance-detail/:params",
    name: "Attendance Approval Application Detail onbehalf",
    component: Pages["ApprovalAttendanceDetailOnBehalf"],
    meta: {
      router: "/delegated-approval-record/attendance-detail/:params",
      icon: "",
      text: "label_essweb_approvalProcess_form_attendanceTitle",
      bred: "/delegated-approval-record/attendance-detail/:params",
    },
  },
  {
    path: "delegated-approval-record/attendance-detail/:params/approval-detail/:args",
    name: "attendance Approval Proxy Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/delegated-approval-record/attendance-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/delegated-approval-record/attendance-detail/:params/approval-detail/:args",
    },
  },
  // Approval OnBehalf--Roster
  {
    path: "delegated-approval-record/roster-detail/:params",
    name: "Roster Approval Application Detail2",
    component: Pages["ApprovalRosterDetailOnBehalf"],
    meta: {
      router: "/delegated-approval-record/roster-detail/:params",
      icon: "",
      text: "label_essweb_approvalApplication_form_viewTitle",
      bred: "/delegated-approval-record/roster-detail/:params",
    },
  },
  {
    path: "delegated-approval-record/roster-detail/:params/approval-detail/:args",
    name: "roster Approval Proxy Detail ",
    component: Pages["Status"],
    meta: {
      router:
        "/delegated-approval-record/roster-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/delegated-approval-record/roster-detail/:params/approval-detail/:args",
    },
  },
  // Approval OnBehalf-- OnBehalf Received Setting
  {
    path: "approval-onbehalf-received-application",
    name: "Approval OnBehalf Received Application",
    component: Pages["ApprovalOnBehalfReceivedApplication"],
    meta: {
      router: "/approval-onbehalf-received-application",
      icon: "",
      text: "label_essweb_approvalOnBehalfReceivedApplication_list_title",
      bred: "/approval-onbehalf-received-application",
    },
  },
  {
    path: "approval-onbehalf-received-application/detail/:id",
    name: "View Approval OnBehalf Received Application",
    component: Pages["ViewApprovalOnBehalfReceivedApplication"],
    meta: {
      router: "/approval-onbehalf-received-application/detail/:id",
      icon: "",
      text: "label_essweb_approvalOnBehalfReceivedApplication_form_viewTitle",
      bred: "/approval-onbehalf-received-application/detail/:id",
    },
  },
  // Approval OnBehalf-- OnBehalf Setting
  {
    path: "approval-delegation",
    name: "Approval OnBehalf Setting Application",
    component: Pages["ApprovalOnBehalfSettingApplication"],
    meta: {
      router: "/approval-delegation",
      icon: "",
      text: "label_essweb_approvalOnBehalfSetting_list_title",
      bred: "/approval-delegation",
    },
  },
  {
    path: "approval-delegation/add/:id",
    name: "New Approval OnBehalf Setting Application",
    component: Pages["newApprovalOnBehalfSetting"],
    meta: {
      router: "/approval-delegation/add/:id",
      icon: "",
      text: "label_essweb_approvalOnBehalfSetting_form_newTitle",
      bred: "/approval-delegation/add/:id",
    },
  },
  {
    path: "approval-delegation/detail/:id",
    name: "View Approval OnBehalf Setting ",
    component: Pages["ViewApprovalOnBehalfSetting"],
    meta: {
      router: "/approval-delegation/detail/:id",
      icon: "",
      text: "label_essweb_approvalOnBehalfSetting_form_viewTitle",
      bred: "/approval-delegation/detail/:id",
    },
  },

  // My Application
  {
    path: "my-application",
    name: "My Application",
    component: Pages["MyApplication"],
    meta: {
      router: "/my-application",
      icon: "",
      text: "label_essweb_myApplication_list_title",
      bred: "/my-application",
    },
  },
  // My Application--Abnormal
  {
    path: "my-application/abnormal-detail/:params",
    name: "My Application Abnormal Detail",
    component: Pages["AbnormalDetail"],
    meta: {
      router: "/my-application/abnormal-detail/:params",
      icon: "",
      text: "label_essweb_abnormalClockin_form_title",
      bred: "/my-application/abnormal-detail/:params",
    },
  },
  {
    path: "my-application/abnormal-detail/:params/approval-detail/:args",
    name: "my Abnormal Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-application/abnormal-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-application/abnormal-detail/:params/approval-detail/:args",
    },
  },
  // My Application--Attendance
  {
    path: "my-application/attendance-detail/:params",
    name: "My Application Attendance Detail",
    component: Pages["AttendanceDetail"],
    meta: {
      router: "/my-application/attendance-detail/:params",
      icon: "",
      text: "label_essweb_attendanceModifiApp_form_viewTitle",
      bred: "/my-application/attendance-detail/:params",
    },
  },
  {
    path: "my-application/attendance-detail/:params/approval-detail/:args",
    name: "my attendance Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-application/attendance-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-application/attendance-detail/:params/approval-detail/:args",
    },
  },
  // My Application--Custom Form
  {
    path: "my-application/custom-form-detail/:params",
    name: "My custom Form Attendance Detail",
    component: Pages["CustomFormDetail"],
    meta: {
      router: "/my-application/custom-form-detail/:params",
      icon: "",
      text: "label_essweb_CustomFormRecord_list_viewTitle",
      bred: "/my-application/custom-form-detail/:params",
    },
  },
  {
    path: "my-application/custom-form-detail/:params/approval-detail/:args",
    name: "my custom form Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/my-application/custom-form-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-application/custom-form-detail/:params/approval-detail/:args",
    },
  },
  // My Application--CLaim
  {
    path: "my-application/claim-detail/:params",
    name: "My Application Claim Detail",
    component: Pages["ClaimDetail"],
    meta: {
      router: "/my-application/claim-detail/:params",
      icon: "",
      text: "label_essweb_myClaimApplication_form_viewTitle",
      bred: "/my-application/claim-detail/:params",
    },
  },
  {
    path: "my-application/claim-detail/:params/approval-detail/:args",
    name: "my claim Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-application/claim-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-application/claim-detail/:params/approval-detail/:args",
    },
  },
  // My Application--Leave
  {
    path: "my-application/leave-detail/:params",
    name: "My Application Leave Detail",
    component: Pages["LeaveDetail"],
    meta: {
      router: "/my-application/leave-detail/:params",
      icon: "",
      text: "label_essweb_leaveApplication_form_viewTitle",
      bred: "/my-application/leave-detail/:params",
    },
  },
  {
    path: "my-application/leave-detail/:params/approval-detail/:args",
    name: "my leave Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-application/leave-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-application/leave-detail/:params/approval-detail/:args",
    },
  },
  // My Application--Roster
  {
    path: "my-application/roster-detail/:params",
    name: "My Application Roster Detail",
    component: Pages["RosterDetail"],
    meta: {
      router: "/my-application/roster-detail/:params",
      icon: "",
      text: "label_essweb_myApplication_form_viewTitle",
      bred: "/my-application/roster-detail/:params",
    },
  },
  {
    path: "my-application/roster-detail/:params/approval-detail/:args",
    name: "my roster Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/my-application/roster-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-application/roster-detail/:params/approval-detail/:args",
    },
  },
  // My onBehalf Application
  {
    path: "my-onbehalf-application",
    name: "Application On Behalf",
    component: Pages["ApplicationOnBehalf"],
    meta: {
      router: "/my-onbehalf-application",
      icon: "",
      text: "label_essweb_applicationOnBehalf_list_title",
      bred: "/my-onbehalf-application",
    },
  },
  // My onBehalf Application--Abnormal
  {
    path: "my-onbehalf-application/abnormal-detail/:params",
    name: "My Onbehalf Application Abnormal Detail",
    component: Pages["AbnormalDetail"],
    meta: {
      router: "/my-onbehalf-application/abnormal-detail/:params",
      icon: "",
      text: "label_essweb_abnormalClockin_form_title",
      bred: "/my-onbehalf-application/abnormal-detail/:params",
    },
  },
  {
    path: "my-onbehalf-application/abnormal-detail/:params/approval-detail/:args",
    name: "my onbehalf Abnormal Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/my-onbehalf-application/abnormal-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-onbehalf-application/abnormal-detail/:params/approval-detail/:args",
    },
  },
  // My onBehalf Application--Attendance
  {
    path: "my-onbehalf-application/attendance-detail/:params",
    name: "My Onbehalf Application Attendance Detail",
    component: Pages["AttendanceDetail"],
    meta: {
      router: "/my-onbehalf-application/attendance-detail/:params",
      icon: "",
      text: "label_essweb_attendanceModifiApp_form_viewTitle",
      bred: "/my-onbehalf-application/attendance-detail/:params",
    },
  },
  {
    path: "my-onbehalf-application/attendance-detail/:params/approval-detail/:args",
    name: "my onbehalf attendance Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/my-onbehalf-application/attendance-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-onbehalf-application/attendance-detail/:params/approval-detail/:args",
    },
  },
  // My onBehalf Application--Custom Form
  {
    path: "my-onbehalf-application/custom-form-detail/:params",
    name: "My Onbehalf Application custom form Detail",
    component: Pages["CustomFormDetail"],
    meta: {
      router: "/my-onbehalf-application/custom-form-detail/:params",
      icon: "",
      text: "label_essweb_CustomFormRecord_list_viewTitle",
      bred: "/my-onbehalf-application/custom-form-detail/:params",
    },
  },
  {
    path: "my-onbehalf-application/custom-form-detail/:params/approval-detail/:args",
    name: "my onbehalf custom form Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/my-onbehalf-application/custom-form-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-onbehalf-application/custom-form-detail/:params/approval-detail/:args",
    },
  },
  // My onBehalf Application--Claim
  {
    path: "my-onbehalf-application/claim-detail/:params",
    name: "My Onbehalf Application Claim Detail",
    component: Pages["ClaimDetail"],
    meta: {
      router: "/my-onbehalf-application/claim-detail/:params",
      icon: "",
      text: "label_essweb_myClaimApplication_form_viewTitle",
      bred: "/my-onbehalf-application/claim-detail/:params",
    },
  },
  {
    path: "my-onbehalf-application/claim-detail/:params/approval-detail/:args",
    name: "my onbehalf claim Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/my-onbehalf-application/claim-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-onbehalf-application/claim-detail/:params/approval-detail/:args",
    },
  },
  // My onBehalf Application--Leave
  {
    path: "my-onbehalf-application/leave-detail/:params",
    name: "My Onbehalf Application Leave Detail",
    component: Pages["LeaveDetail"],
    meta: {
      router: "/my-onbehalf-application/leave-detail/:params",
      icon: "",
      text: "label_essweb_leaveApplication_form_viewTitle",
      bred: "/my-onbehalf-application/leave-detail/:params",
    },
  },
  {
    path: "my-onbehalf-application/leave-detail/:params/approval-detail/:args",
    name: "my onbehalf leave Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/my-onbehalf-application/leave-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-onbehalf-application/leave-detail/:params/approval-detail/:args",
    },
  },
  // My onBehalf Application--Roster
  {
    path: "my-onbehalf-application/roster-detail/:params",
    name: "My Onbehalf Application Roster Detail",
    component: Pages["RosterDetail"],
    meta: {
      router: "/my-onbehalf-application/roster-detail/:params",
      icon: "",
      text: "label_essweb_myApplication_form_viewTitle",
      bred: "/my-onbehalf-application/roster-detail/:params",
    },
  },
  {
    path: "my-onbehalf-application/roster-detail/:params/approval-detail/:args",
    name: "my  Onbehalf roster Approval Detail",
    component: Pages["Status"],
    meta: {
      router:
        "/my-onbehalf-application/roster-detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/my-onbehalf-application/roster-detail/:params/approval-detail/:args",
    },
  },
  // Custom Form Record
  {
    path: "custom-form-record",
    name: "custom form record",
    component: Pages["CustomFormRecord"],
    meta: {
      router: "/custom-form-record",
      icon: "",
      text: "label_essweb_CustomFormRecord_list_title",
      bred: "/custom-form-record",
    },
  },
  {
    path: "custom-form-record/add/:args",
    name: "New custom form record",
    component: Pages["newCustomFormRecord"],
    meta: {
      router: "/custom-form-record/add/:args",
      icon: "",
      text: "label_essweb_CustomFormRecord_list_newTitle",
      bred: "/custom-form-record/add/:args",
    },
  },
  {
    path: "custom-form-record/detail/:params",
    name: "View custom form record",
    component: Pages["viewCustomFormRecord"],
    meta: {
      router: "/custom-form-record/detail/:params",
      icon: "",
      text: "label_essweb_CustomFormRecord_list_viewTitle",
      bred: "/custom-form-record/detail/:params",
    },
  },
  {
    path: "custom-form-record/detail/:params/approval-detail/:args",
    name: "custom form record Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/custom-form-record/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/custom-form-record/detail/:params/approval-detail/:args",
    },
  },
  //My Attendance
  {
    path: "my-attendance", //我的考勤
    name: "My Attendance",
    component: Pages["MyAttendance"],
    meta: {
      router: "/my-attendance",
      icon: "",
      keepAlive: true,
      text: "label_essweb_myAttendanceRecord_list_title",
      bred: "/my-attendance",
    },
  },
  {
    path: "my-attendance/detail/:id",
    name: "View My Attendance",
    component: Pages["ViewMyAttendance"],
    meta: {
      router: "/my-attendance/detail/:id",
      icon: "",
      cachePre: true, //缓存上一页
      text: "label_essweb_myAttendanceRecord_form_viewTitle",
      bred: "/my-attendance/detail/:id",
    },
  },
  //Subordinate Attendance
  {
    path: "subordinate-attendance",
    name: "Subordinate Attendance",
    component: Pages["SubordinateAttendance"],
    meta: {
      router: "/subordinate-attendance",
      keepAlive: true,
      icon: "",
      text: "label_essweb_subordinateAttendanceRecord_list_title",
      bred: "/subordinate-attendance",
    },
  },
  {
    path: "subordinate-attendance/detail/:id",
    name: "View Subordinate Attendance",
    component: Pages["ViewSubordinateAttendance"],
    meta: {
      router: "/subordinate-attendance/detail/:id",
      cachePre: true, //缓存上一页
      icon: "",
      text: "label_essweb_subordinateAttendanceRecord_form_viewTitle",
      bred: "/subordinate-attendance/detail/:id",
    },
  },
  //Attendance Record Modification Application
  {
    path: "attendance-modification",
    name: "Attendance Record Modification Application",
    component: Pages["AttendanceRecordModificationApplication"],
    meta: {
      router: "/attendance-modification",
      icon: "",
      text: "label_essweb_attendanceModifiApp_list_title",
      bred: "/attendance-modification",
    },
  },
  {
    path: "attendance-modification/detail/:params",
    name: "View Attendance Record Modification Application",
    component: Pages["ViewAttendanceRecordModificationApplication"],
    meta: {
      router: "/attendance-modification/detail/:params",
      icon: "",
      text: "label_essweb_attendanceModifiApp_form_viewTitle",
      bred: "/attendance-modification/detail/:params",
    },
  },
  {
    path: "attendance-modification/detail/:params/approval-detail/:args",
    name: "View Attendance Record Modification Application approval detail",
    component: Pages["Status"],
    meta: {
      router: "/attendance-modification/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/attendance-modification/detail/:params/approval-detail/:args",
    },
  },
  // Abnormal ClockIn
  {
    path: "abnormal-clock-in",
    name: "Abnormal ClockIn",
    component: Pages["AbnormalClockIn"],
    meta: {
      router: "/abnormal-clock-in",
      icon: "",
      keepAlive: true,
      text: "label_essweb_abnormalClockin_list_title",
      bred: "/abnormal-clock-in",
    },
  },
  {
    path: "abnormal-clock-in/detail/:params",
    name: "View Abnormal ClockIn",
    component: Pages["ViewAbnormalClockIn"],
    meta: {
      router: "/abnormal-clock-in/detail/:params",
      icon: "",
      cachePre: true,
      text: "label_essweb_abnormalClockin_form_title",
      bred: "/abnormal-clock-in/detail/:params",
    },
  },
  {
    path: "abnormal-clock-in/detail/:params/approval-detail/:args",
    name: "View Abnormal ClockIn Approval Detail",
    component: Pages["Status"],
    meta: {
      router: "/abnormal-clock-in/detail/:params/approval-detail/:args",
      icon: "",
      text: "label_essweb_Status_list_title",
      bred: "/abnormal-clock-in/detail/:params/approval-detail/:args",
    },
  },
  //Punch Record
  {
    path: "clock-in",
    name: "Punch Record1",
    component: Pages["PunchRecord"],
    meta: {
      router: "/clock-in",
      icon: "",
      text: "label_essweb_punchRecord_list_title",
      bred: "/clock-in",
    },
  },
  //Announcement
  {
    path: "company-announcement",
    name: "company Announcement",
    component: Pages["Announcement"],
    meta: {
      router: "/company-announcement",
      icon: "",
      text: "label_essweb_Announcement_list_title",
      bred: "/company-announcement",
    },
  },
  // Payslip
  {
    path: "/pay-slip",
    name: "Payslip user",
    component: Pages["Payslip"],
    meta: {
      router: "/pay-slip",
      icon: "",
      text: "label_essweb_Payslip_list_title",
      bred: "/pay-slip",
    },
  },
  // Tax Form
  {
    path: "/tax-form",
    name: "Tax user",
    component: Pages["Tax"],
    meta: {
      router: "/tax-form",
      icon: "",
      text: "label_essweb_Tax_list_title",
      bred: "/tax-form",
    },
  },
  // Document Center
  {
    path: "/document-center",
    name: "Document Center",
    component: Pages["DocumentCenter"],
    meta: {
      router: "/document-center",
      icon: "",
      text: "label_essweb_DocumentCenter_list_title",
      bred: "/document-center",
    },
  },
];
